import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 캐럿글로벌
  {
    path: "/",
    component: () => import("@/page/NewGlobal/Main.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  // 캐럿글로벌 - 개인정보처리방침
  {
    path: "/PrivacyPolicy",
    component: () => import("@/page/NewGlobal/PrivacyPolicy.vue"),
    meta: {
      title: "개인정보처리방침",
    },
  },
  {
    // 캐럿글로벌 - 글로벌 역량
    path: "/Global",
    component: () => import("@/page/NewGlobal/Sub/Global.vue"),
    meta: {
      title: "Global",
    },
  },
  {
    // 캐럿글로벌 - 주재원/현채인 육성
    path: "/Nurture",
    component: () => import("@/page/NewGlobal/Sub/Nurture.vue"),
    meta: {
      title: "Nurture",
    },
  },
  {
    // 캐럿글로벌 - 이문화 역량
    path: "/CrossCulture",
    component: () => import("@/page/NewGlobal/Sub/CrossCulture.vue"),
    meta: {
      title: "CrossCulture",
    },
  },
  {
    // 캐럿글로벌 - 리더십 및 조직개발
    path: "/Leadership",
    component: () => import("@/page/NewGlobal/Sub/Leadership.vue"),
    meta: {
      title: "Leadership",
    },
  },
  {
    // 캐럿글로벌 - 디지털 역량
    path: "/Digital",
    component: () => import("@/page/NewGlobal/Sub/Digital.vue"),
    meta: {
      title: "Digital",
    },
  },
  {
    // 캐럿글로벌 - 맞춤형 해외연수
    path: "/Customized",
    component: () => import("@/page/NewGlobal/Sub/Customized.vue"),
    meta: {
      title: "Customized",
    },
  },
  {
    // 캐럿글로벌 - 진단 및 컨설팅
    path: "/Consulting",
    component: () => import("@/page/NewGlobal/Sub/Consulting.vue"),
    meta: {
      title: "Consulting",
    },
  },
  {
    // 회사소개
    path: "/Introduce",
    component: () => import("@/page/NewGlobal/Introduce/Main.vue"),
    meta: {
      title: "Introduce",
    },
  },
  {
    // 회사소개 - 경영철학
    path: "/Philosophy",
    component: () => import("@/page/NewGlobal/Introduce/Philosophy.vue"),
    meta: {
      title: "Philosophy",
    },
  },
  {
    // 회사소개 - 기업문화
    path: "/Culture",
    component: () => import("@/page/NewGlobal/Introduce/Culture.vue"),
    meta: {
      title: "Culture",
    },
  },
  {
    // 회사소개 - CEO 메세지
    path: "/Ceo",
    component: () => import("@/page/NewGlobal/Introduce/Ceo.vue"),
    meta: {
      title: "Ceo",
    },
  },
  {
    // 회사소개 - CEO 메세지 목록
    path: "/CeoList",
    component: () => import("@/page/NewGlobal/Introduce/CeoList.vue"),
    meta: {
      title: "CeoList",
    },
  },
  {
    // 회사소개 - CEO 메세지 상세
    path: "/CeoDetail",
    component: () => import("@/page/NewGlobal/Introduce/CeoDetail.vue"),
    meta: {
      title: "CeoDetail",
    },
  },
  {
    // 회사소개 - 연구발표
    path: "/Articles",
    component: () => import("@/page/NewGlobal/Introduce/Articles.vue"),
    meta: {
      title: "Articles",
    },
  },
  {
    // 회사소개 - 회사연혁
    path: "/History",
    component: () => import("@/page/NewGlobal/Introduce/History.vue"),
    meta: {
      title: "History",
    },
  },
  {
    // 회사소개 - 보도자료
    path: "/News",
    component: () => import("@/page/NewGlobal/Introduce/News.vue"),
    meta: {
      title: "News",
    },
  },
  {
    // 회사소개 - 보도자료
    path: "/Admin/News",
    component: () => import("@/page/NewGlobal/Introduce/News.vue"),
    meta: {
      title: "News",
    },
  },
  {
    // 회사소개 - 보도자료 상세
    path: "/NewsDetail",
    component: () => import("@/page/NewGlobal/Introduce/NewsDetail.vue"),
    meta: {
      title: "NewsDetail",
    },
  },
  {
    // 회사소개 - 보도자료 상세
    path: "/Admin/NewsDetail",
    component: () => import("@/page/NewGlobal/Introduce/NewsDetail.vue"),
    meta: {
      title: "NewsDetail",
    },
  },
  {
    // 회사소개 - 보도자료 작성, 수정
    path: "/NewsCreate",
    component: () => import("@/page/NewGlobal/Introduce/NewsCreate.vue"),
    meta: {
      title: "NewsCreate",
    },
  },
  {
    // 회사소개 - 인재채용
    path: "/Recruit",
    component: () => import("@/page/NewGlobal/Introduce/Recruit.vue"),
    meta: {
      title: "Recruit",
    },
  },
  {
    // 이미지 뷰어
    path: "/ImageView",
    name: "ImageView",
    component: () => import("@/page/NewGlobal/ImageView.vue"),
    meta: {
      title: "ImageView",
    },
  },

  // 상반기 전체 DM
  {
    path: "/2024_schedule",
    component: () => import("@/page/NewGlobal/2024/Schedule.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    // 주재원 핵심역량 강화 과정
    path: "/2024_dm1",
    component: () => import("@/page/NewGlobal/2024/dm1.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    // ccl leadership 성공하는 리더들의 4가지 원칙 과정
    path: "/2024_dm2",
    component: () => import("@/page/NewGlobal/2024/dm2.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    // gtms 글로벌 경영시뮬레이션 과정
    path: "/2024_dm4",
    component: () => import("@/page/NewGlobal/2024/dm4.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    // corestrengths 업무성향진단 과정
    path: "/2024_dm5",
    component: () => import("@/page/NewGlobal/2024/dm5.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },

  //캐럿 솔루션즈 사이트
  // {
  //   path: "/",
  //   component: () => import("@/page/AITutoring/Index"),
  //   meta: {
  //     title: "aitutor",
  //   },
  // },
  // {
  //   path: "/aitutoring",
  //   component: () => import("@/page/AITutoring/Index"),
  //   meta: {
  //     title: "aitutoring",
  //   },
  // },
  // {
  //   path: "/aitutoring/payment",
  //   component: () => import("@/page/AITutoring/Payment"),
  //   meta: {
  //     title: "payment",
  //   },
  // },
  // {
  //   path: "/aitutoring/faq",
  //   component: () => import("@/page/AITutoring/Faq"),
  //   meta: {
  //     title: "faq",
  //   },
  // },
  // {
  //   path: "/aitutoring/privacy",
  //   component: () => import("@/page/AITutoring/Privacy"),
  //   meta: {
  //     title: "privacy",
  //   },
  // },
  // {
  //   path: "/aitutoring/terms",
  //   component: () => import("@/page/AITutoring/Terms"),
  //   meta: {
  //     title: "terms",
  //   },
  // },
  // {
  //   path: "/customcont",
  //   component: () => import("@/page/CustomCont"),
  //   meta: {
  //     title: "CarrotSolutions",
  //   },
  // },

  // 사보 당근농장 >> 캐럿글로벌 사이트 리뉴얼 후 제거됨.
  {
    path: "/news-letter",
    component: () => import("@/page/NewsLetter"),
  },
  {
    name: "news-detail",
    path: "/news-detail/:idx",
    component: () => import("@/page/NewsDetail"),
  },

  // 리로케이션 서비스 사이트
  {
    path: "/re-location",
    component: () => import("@/relocation/ReLocation.vue"),
    alias: ["/apply"],
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact",
    component: () => import("@/relocation/ReLocationContact.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact-02/:idx",
    component: () => import("@/relocation/ReLocationContact_02.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    name: "re-location-contact-03",
    path: "/re-location-contact-03/:regid",
    props: true,
    component: () => import("@/relocation/ReLocationContact_03.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact-04",
    component: () => import("@/relocation/ReLocationContact_04.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/re-location-contact-04",
    component: () => import("@/relocation/ReLocationContact_04.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },

  // 구 캐럿글로벌
  {
    path: "/global",
    component: () => import("@/page/Global/CarrotGlobal.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global-sub1",
    component: () => import("@/page/Global/CarrotGlobalSub1.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global-sub2",
    component: () => import("@/page/Global/CarrotGlobalSub2.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global-sub3",
    component: () => import("@/page/Global/CarrotGlobalSub3.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global-sub4",
    component: () => import("@/page/Global/CarrotGlobalSub4.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global-sub5",
    component: () => import("@/page/Global/CarrotGlobalSub5.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global-sub6",
    component: () => import("@/page/Global/CarrotGlobalSub6.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },

  // 명절 선물 주소입력 사이트
  {
    path: "/holiday_gift/tutor",
    component: () => import("@/holiday_gift/tutor.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },
  {
    path: "/holiday_gift/client",
    component: () => import("@/holiday_gift/client.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },
  {
    path: "/holiday_gift/finish",
    component: () => import("@/holiday_gift/finish.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },

  // 고객사 수강신청 랜딩 사이트
  {
    path: "/global_edu/samsung",
    component: () => import("@/page/Samsung/Enrolment.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global_edu/Ssyenc",
    component: () => import("@/page/Ssyenc/Enrolment.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },
  {
    path: "/global_edu/skhynix",
    component: () => import("@/page/GlobalEdu/SkHynix.vue"),
    meta: {
      title: "sk 하이닉스 needs 조사",
    },
  },
  {
    path: "/global_edu/inchon_seogu",
    component: () => import("@/page/IncheonSeogu/Enrolment.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },
  {
    path: "/global_edu/gjrepresent",
    component: () => import("@/page/Gijang/Represent.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },
  {
    path: "/gijangcamp",
    component: () => import("@/page/Gijang/gijangcamp.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },
  {
    path: "/gijangcamp/notice",
    component: () => import("@/page/Gijang/Notice.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },
  {
    path: "/gijangcamp/schedule",
    component: () => import("@/page/Gijang/Schedule.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },

  // 당근영어
  {
    path: "/carrot_event",
    component: () => import("@/page/CarrotEvent/Enrolment.vue"),
    meta: {
      title: "CarrotSolutions",
    },
  },

  // 맞춤표현집 앱 다운로드
  {
    path: "/Biz_English/down",
    component: () => import("@/page/CustomExpressionBookApp/down.vue"),
    meta: {
      title: "Biz.English",
    },
  },

  // 스피킹랩
  {
    path: "/Speakinglab/down",
    component: () => import("@/page/Speakinglab/down.vue"),
    meta: {
      title: "CarrotGlobal",
    },
  },

  // 테스트용 임시 페이지
  {
    path: "/test",
    component: () => import("@/page/Test"),
  },
];

const carrotglobal = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

carrotglobal.afterEach((to) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default carrotglobal;
